
document.addEventListener('DOMContentLoaded', () => {
    const applyMouseHoverMenu = () => {
    const headerWrapper = document.querySelector('.header-wrapper');
    const mainDropMenuSetting = headerWrapper ? headerWrapper.dataset.maindrop : 'click';

    if (mainDropMenuSetting === 'mousehover') {
        let currentlyOpenMenu = null; // To keep track of the currently open menu
        let currentlyChildOpenMenu = null; // To keep track of the currently child open menu
        

        const expandMenu = (event) => {
        const summary = event.currentTarget;
        const parentElement = summary.parentElement;

        if (summary) {
            summary.setAttribute('aria-expanded', true);
        }
        parentElement.setAttribute('open', 'true');
        if (currentlyChildOpenMenu && currentlyChildOpenMenu !== parentElement && parentElement.dataset.isChild) {
            const previousSummary = currentlyChildOpenMenu.querySelector('summary');
            if (previousSummary) {
            previousSummary.setAttribute('aria-expanded', false);
            }
            currentlyChildOpenMenu.removeAttribute('open');
            currentlyChildOpenMenu = parentElement;
            return;
        } else if(parentElement.dataset.isChild){
            currentlyChildOpenMenu = parentElement;
            return;
        }

        if (currentlyOpenMenu && currentlyOpenMenu !== parentElement) {
            const previousSummary = currentlyOpenMenu.querySelector('summary');
            if (previousSummary) {
            previousSummary.setAttribute('aria-expanded', false);
            }
            currentlyOpenMenu.removeAttribute('open');
        }

        
        currentlyOpenMenu = parentElement;
        };

        const collapseMenu = (event) => {
        const parentElement = event.currentTarget;
        const summary = parentElement.querySelector('summary');

        setTimeout(() => {
            if (!parentElement.matches(':hover') && !parentElement.querySelector('.mega-menu__content:hover')) {
            if (summary) {
                summary.setAttribute('aria-expanded', false);
            }
            parentElement.removeAttribute('open');
            if (currentlyOpenMenu === parentElement) {
                currentlyOpenMenu = null;
            }
            }
        }, 200);
        };

        document.querySelectorAll('[id^="Details-"]').forEach(parentElement => {
        if (parentElement) {
            const summary = parentElement.querySelector('summary');
            const megaMenuContent = parentElement.querySelector('.mega-menu__content');

            if (summary) {
            summary.addEventListener('mouseenter', expandMenu);
            summary.addEventListener('mouseleave', collapseMenu);
            }

            if (megaMenuContent) {
            megaMenuContent.addEventListener('mouseenter', expandMenu);
            megaMenuContent.addEventListener('mouseleave', collapseMenu);
            }

            // Add event listener to parent element
            if (parentElement) {
            parentElement.addEventListener('mouseleave', collapseMenu);
            }
        }
        });
    }
    };

    // Apply mouse hover menu based on screen size
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    const handleMediaQueryChange = (e) => {
    if (e.matches) {
        applyMouseHoverMenu();
    }
    };
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaQueryChange);
});